var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIroncondor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H49",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 43.5V44H14.793H15.1236L15.2531 43.6957L19.0795 34.6996L19.0812 34.6957L24.8276 21.5H30.5033L35.5329 34.6783L35.6557 35H36H40.2617H40.9987L40.7263 34.3152L33.9646 17.3152L33.8392 17H33.5H21.5H21.1678L21.0391 17.3063L13.8958 34.3032L13.8945 34.3063L11.6702 39.5H8.5V40L8 43.5Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8263 44H39.4956L39.3662 43.6957L35.5381 34.6957L35.2422 34H35.9982H40.2638H40.5936L40.7234 34.3032L42.9491 39.5H45.2443H48.5V40V43.5V44H45.7746H39.8263Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5292 44.5H14.8599L14.9893 44.1957L18.8174 35.1957L19.1133 34.5H18.3573H14.0917H13.7619L13.6321 34.8032L11.4064 40H9.11118H8.68128L8.61678 40.4251L8.08658 43.9251L7.99948 44.5H8.58088H14.5292Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIroncondor);
export default __webpack_public_path__ + "static/media/iron condor.976a1c8bf5f6501c0d53e40cfab2a93f.svg";
export { ForwardRef as ReactComponent };